import Translation from "components/Translation"
import React from "react"
import { FeatureFlagTypes } from "components/SupportSettingsToggler/types"
import { EmployeeSettingsRoutes } from "app/routes/types"

export default [
  {
    id: EmployeeSettingsRoutes.PersonalAbsences,
    label: <Translation label="employee.settings.tab.entitlements" />,
    featureRestriction: FeatureFlagTypes.LeaveEntitlements,
  },
]
